import lazyBackground from './lazyBackground'
import lazyImage from './lazyImage'

export const vLazyBackground = lazyBackground
export const vLazyImage = lazyImage
